require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/es7.symbol.observable.js
// module id = tw3T
// module chunks = 0